<div class="leftpanel">
    <div class="sidenav-user" *ngIf="userData">
        <h4 class="sidenav-user-name">{{commonService.getFullName(userData?.firstName, userData?.lastName)}}</h4>
        <div class="profileimgsec">
            <img class="sidenav-user-image" src="{{userData?.profilePicture}}">
            <span class="status" [ngStyle]="customerStatus ==='Active'? {'background-color': 'green'} : {'background-color': 'red'}"></span>
        </div>
        
        
        <h5 class="sidenav-user-email"><mat-icon> place</mat-icon> {{userPlace}} </h5>
        <h5 class="sidenav-user-email"><mat-icon> email</mat-icon> {{userData?.emailAddress}}</h5>
        <h5 class="sidenav-user-email"><mat-icon> phone</mat-icon> {{userData?.phoneNumber | mask: '(000) 000-0000'}} </h5>
        <div class="status_review" *ngIf="statusLight?.status === 'Past Due'" [class]="statusLight?.color">
            <div class="left">
                <h3>
                    Past Due
                </h3>
                <!-- <small>
                    {{statusLight.totalCount}} Payments
                </small> -->
            </div>
            <div style="margin-left: -50px;">
                <!-- <img src="assets/img/step-arrow.svg"/> -->
                <small>
                    {{statusLight.totalCount}} Payments
                </small>
            </div>
            <div class="currency">
                {{statusLight.totalDue| currency}} 
            </div>
        </div>
        <div class="status_review" *ngIf="statusLight?.status === 'Cancelled'" [class]="statusLight?.color">
            <div class="left">
                <h3>
                    Cancelled 
                </h3>
            </div>
            <div>
                <small>
                    {{statusLight.totalCount}} Cancelled Agreements
                </small>
            </div>
        </div>
        <div class="status_review" *ngIf="statusLight?.status === 'Expired'" [class]="statusLight?.color">
            <div class="left">
                <h3>
                    Expired 
                </h3>
            </div>
            <div>
                <small>
                    {{statusLight.totalCount}} Expired Agreements
                </small>
            </div>
        </div>
        <div class="status_review" *ngIf="statusLight?.status === 'Declined'" [class]="statusLight?.color">
            <div class="left">
                <h3>
                    Declined 
                </h3>
            </div>
            <div>
                <small>
                    {{statusLight.totalCount}} Declined Agreements
                </small>
            </div>
        </div>
        <div class="status_review" *ngIf="statusLight?.status === 'Pending Payment'" [class]="statusLight?.color">
            <div class="left">
                <h3>
                    Pending Payment  
                </h3>
            </div>
            <div style="margin-left: -50px;">
                <small>
                    {{statusLight.totalCount}} Pending Payments
                </small>
            </div>
            <div class="currency">
                {{statusLight.totalDue| currency}}
            </div>
        </div>
        <!-- <span class="status_review" *ngIf="statusLight?.status === 'Past Due'" [class]="statusLight?.color">Past Due    {{statusLight.totalDue| currency}}     {{statusLight.totalCount}} Payments</span>
        <span class="status_review" *ngIf="statusLight?.status === 'Cancelled'" [class]="statusLight?.color">Cancelled   {{statusLight.totalCount}} Cancelled Agreements</span>
        <span class="status_review" *ngIf="statusLight?.status === 'Expired'" [class]="statusLight?.color">Expired   {{statusLight.totalCount}} Expired Agreements</span>
        <span class="status_review" *ngIf="statusLight?.status === 'Declined'" [class]="statusLight?.color">Declined   {{statusLight.totalCount}} Declined Agreements</span>
        <span class="status_review" *ngIf="statusLight?.status === 'Pending Payment'" [class]="statusLight?.color">Pending Payment  {{statusLight.totalDue| currency}}   {{statusLight.totalCount}} Pending Payments</span> -->
        
    </div>
    <div class="billing_prt">
        <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" expanded>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h3 class="panel-title main-title">
                        Billing Information
                    </h3>
                    
                  </mat-panel-title>
                  
                </mat-expansion-panel-header>
            
                <div class="info_detail">
                    <span>
                        <label>
                            Address:
                        </label>
                        {{userData?.billingAddress?.streetAddress}}
                    </span>
                    <span *ngIf="userData?.billingAddress?.unitNumber">
                        <label>
                            Unit No:
                        </label>
                        {{userData?.billingAddress?.unitNumber}}
                    </span>
                    <span>
                        <label>
                           City:
                        </label>
                        {{userData?.billingAddress?.city}}
                    </span>
                    <span>
                        <label>
                            State:
                        </label>
                        <p>{{userData?.billingAddress?.state}}</p>
                    </span>
                    <span>
                        <label>
                            Zip:
                        </label>
                        <p>{{userData?.billingAddress?.zip}}</p>
                    </span>
                </div>
            
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h3 class="panel-title main-title">
                        Mailing Information
                    </h3>
                    
                  </mat-panel-title>
                  
                </mat-expansion-panel-header>
            
                <div class="info_detail">
                    <span>
                        <label>
                            Address:
                        </label>
                        {{userData?.mailingAddress?.streetAddress}}
                    </span>
                    <span *ngIf="userData?.mailingAddress?.unitNumber">
                        <label>
                            Unit No:
                        </label>
                        {{userData?.mailingAddress?.unitNumber}}
                    </span>
                    <span>
                        <label>
                           City:
                        </label>
                        {{userData?.mailingAddress?.city}}
                    </span>
                    <span>
                        <label>
                            State:
                        </label>
                        <p>{{userData?.mailingAddress?.state}}</p>
                    </span>
                    <span>
                        <label>
                            Zip:
                        </label>
                        <p>{{userData?.mailingAddress?.zip}}</p>
                    </span>
                </div>
            
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h3 class="panel-title main-title">
                        Payment Information
                    </h3>
                    
                  </mat-panel-title>
                  
                </mat-expansion-panel-header>
            
                <ng-container *ngFor="let payment of userData?.userPaymentDetail">
                    <div class="info_detail" *ngIf="payment?.isDefault">
                        <span>
                            <label>
                                Card holder Name:
                            </label>
                            {{payment?.cardDetails?.cardHolderName}}
                        </span>
                        <span>
                            <label>
                                Card number:
                            </label>
                            {{payment?.cardDetails?.cardType === 'American Express' ? 'XXXX XXXXXX X' : 'XXXX XXXX XXXX '}}{{payment?.cardDetails?.cardNumber.slice(-4)}}
                        </span>
                        <span>
                            <label>
                                Card type:
                            </label>
                            {{payment?.cardDetails?.cardType}}
                        </span>
                        <span>
                            <label>
                                Expiry month:
                            </label>
                            {{payment?.cardDetails?.expiryMonth}}
                        </span>
                        <span>
                            <label>
                                Expiry year:
                            </label>
                            {{payment?.cardDetails?.expiryYear}}
                        </span>
                    </div>
                </ng-container>
            
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h3 class="panel-title main-title">
                        IP Addresses
                    </h3>
                    
                  </mat-panel-title>
                  
                </mat-expansion-panel-header>
            
                <div class="info_detail">
                    <span>{{userData?.ipAddress}}</span>
                </div>
            
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h3 class="panel-title main-title">
                        Additional Users
                    </h3>
                    
                  </mat-panel-title>
                  
                </mat-expansion-panel-header>
            
                <div class="info_detail">
                    
                </div>
            
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h3 class="panel-title main-title">
                        Documents 
                    </h3>
                    
                  </mat-panel-title>
                  
                </mat-expansion-panel-header>
            
                <div class="info_detail">
                    
                </div>
            
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h3 class="panel-title main-title">
                        Payment History
                    </h3>
                    
                  </mat-panel-title>
                  
                </mat-expansion-panel-header>
            
                <div class="info_detail">
                    
                </div>
            
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h3 class="panel-title main-title">
                        Password
                    </h3>
                    
                  </mat-panel-title>
                  
                </mat-expansion-panel-header>
            
                <div class="info_detail">
                    
                </div>
            
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>